import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment'
import API from '@/services/api'

const num = v => +v || 0

export const printPackingPDF = async (
    packingList,
    project,
    useSuggested = false,
    returnBlob = false
) => {
    try {
        const {
            data: { settings },
        } = await API.getSettings()
        let company = settings.find(s => s.name == 'Company').generalInfo
        let settingFinish = settings.find(s => s.name == 'FinishAndUCCode')
        const {
            data: { users },
        } = await API.getUsers()
        let pdf = new jsPDF({
            orientation: 'portrait ',
            unit: 'mm',
            format: [216, 279],
        })
        if (useSuggested) {
            pdf = new jsPDF({
                orientation: 'landscape ',
                unit: 'mm',
                format: [279, 216],
            })
        }

        // set header and footer
        const aspectRatio = await getAspectRatio(company.logoBase64)

        const header = function(data) {
            pdf.setFontSize(16)
            pdf.setFont('helvetica', 'bold')
            const text = `Packing List ${packingList.code} | ${project.reference} ${project.name}`
            const maxWidth = 150
            const marginLeft = data.settings.margin.left
            const marginTop = 15
            const splitText = pdf.splitTextToSize(text, maxWidth)
            pdf.text(splitText, marginLeft, marginTop)
            const linesQty = splitText.length
            const startY = 19 + linesQty * 4

            pdf.setFontSize(14)
            pdf.setFont('helvetica', 'normal')
            pdf.text(
                `${moment
                    .unix(
                        packingList.createdOn.seconds ||
                            packingList.createdOn._seconds
                    )
                    .format('YYYY-MM-DD')}`,
                data.settings.margin.left,
                startY
            )
            pdf.setFontSize(11)
            pdf.text(
                'F07-PRED-01 V5 16-04-25',
                data.settings.margin.left,
                startY + 7
            )
            pdf.setFontSize(14)
            // add company logo
            // Calculate available space to avoid overlapping with title
            const titleEndX = marginLeft + maxWidth
            const pageWidth = pdf.internal.pageSize.width
            const marginRight = data.settings.margin.right
            const minGap = 10 // Minimum gap between title and logo
            const maxLogoWidth = pageWidth - titleEndX - marginRight - minGap

            const maxImgHeight = 20
            let imgHeight = maxImgHeight
            let imgWidth = imgHeight * aspectRatio

            // If width exceeds available space, scale down proportionally
            if (imgWidth > maxLogoWidth) {
                imgWidth = maxLogoWidth
                imgHeight = imgWidth / aspectRatio
            }

            const imgX = pageWidth - marginRight - imgWidth
            const imgY = 10
            pdf.addImage(
                company.logoBase64,
                'PNG',
                imgX,
                imgY,
                imgWidth,
                imgHeight
            )
        }

        // Control of footer page
        let lastFooterPage = -1

        const footer = function() {
            const currentPage = pdf.internal.getCurrentPageInfo().pageNumber

            // only paint if the page are not painted.
            if (lastFooterPage !== currentPage) {
                pdf.setLineWidth(0.5)
                pdf.line(
                    10,
                    pdf.internal.pageSize.height - 10,
                    pdf.internal.pageSize.width - 10,
                    pdf.internal.pageSize.height - 10
                )
                pdf.setFontSize(12)
                pdf.text(
                    `${currentPage}`,
                    pdf.internal.pageSize.width - 13,
                    pdf.internal.pageSize.height - 5
                )

                lastFooterPage = currentPage // mark as painted
            }
        }

        const fontSize = 10
        pdf.setFontSize(fontSize)
        const projectManager = findUserInfo(users, project.projectManager)
        const totalWidth = pdf.internal.pageSize.width - 20

        // desc options
        let descriptionOptions = {
            margin: { top: 35, left: 10, right: 10 },
            startY: 40,
            headStyles: {
                fillColor: [211, 211, 211],
                textColor: [0, 0, 0],
            },
            didDrawPage: function(data) {
                header(data)
                footer(data)
            },
        }
        // pick up
        pdf.autoTable({
            head: [
                [
                    'Remission',
                    'Address',
                    'City',
                    'PL Date',
                    'Contact',
                    'Phone',
                    'Pick up',
                ],
            ],
            body: [
                [
                    packingList.remission ? packingList.remission : '-',
                    'ESM',
                    'Barranquilla',
                    moment
                        .unix(
                            packingList.createdOn.seconds ||
                                packingList.createdOn._seconds
                        )
                        .format('YYYY-MM-DD'),
                    projectManager.name,
                    projectManager.phone,
                    packingList.shippedOn
                        ? moment
                              .unix(
                                  packingList.shippedOn.seconds ||
                                      packingList.shippedOn._seconds
                              )
                              .format('YYYY-MM-DD')
                        : '-',
                ],
                [],
            ],
            ...descriptionOptions,
            columnStyles: {
                0: { cellWidth: totalWidth * 0.12 },
                1: { cellWidth: totalWidth * 0.12 },
                2: { cellWidth: totalWidth * 0.13 },
                3: { cellWidth: totalWidth * 0.13 },
                4: { cellWidth: totalWidth * 0.2 },
                5: { cellWidth: totalWidth * 0.17 },
                6: { cellWidth: totalWidth * 0.13 },
            },
        })

        descriptionOptions.startY = pdf.autoTable.previous.finalY - 7
        // delivery
        let contact = ''
        if (
            packingList.deliveryInformation &&
            packingList.deliveryInformation.contact &&
            typeof packingList.deliveryInformation.contact == 'string'
        ) {
            contact = packingList.deliveryInformation.contact
        } else if (
            packingList.deliveryInformation &&
            packingList.deliveryInformation.contact &&
            typeof packingList.deliveryInformation.contact == 'object' &&
            packingList.deliveryInformation.contact.name
        ) {
            contact = packingList.deliveryInformation.contact.name
        }
        pdf.autoTable({
            head: [['Container', 'Address', 'Contact', 'Phone', 'Delivery']],
            body: [
                [
                    packingList.container ? packingList.container : '-',
                    packingList.deliveryInformation
                        ? packingList.deliveryInformation.location
                            ? packingList.deliveryInformation.location
                            : '-'
                        : '-',
                    packingList.deliveryInformation
                        ? packingList.deliveryInformation.contact
                            ? contact
                            : '-'
                        : '-',
                    packingList.deliveryInformation
                        ? packingList.deliveryInformation.phone
                            ? packingList.deliveryInformation.phone
                            : '-'
                        : '-',
                    packingList.shippedOn
                        ? moment
                              .unix(
                                  packingList.shippedOn.seconds ||
                                      packingList.shippedOn._seconds
                              )
                              .format('YYYY-MM-DD')
                        : '-',
                ],
                [],
            ],
            ...descriptionOptions,
            columnStyles: {
                0: { cellWidth: totalWidth * 0.2 },
                1: { cellWidth: totalWidth * 0.2 },
                2: { cellWidth: totalWidth * 0.2 },
                3: { cellWidth: totalWidth * 0.2 },
                4: { cellWidth: totalWidth * 0.2 },
            },
        })

        descriptionOptions.startY = pdf.autoTable.previous.finalY - 7
        // vendor
        pdf.autoTable({
            head: [['Vendor Name', 'NIT', 'Address', 'City', 'Scope']],
            body: [
                [
                    'C.I. ES METALS S.A.S | www.es-metals.com',
                    '901.240.800-3',
                    'Carrera 72A # 107-33',
                    'Barranquilla, Colombia',
                    packingList.scopes ? packingList.scopes : '-',
                ],
                [],
            ],
            ...descriptionOptions,
            columnStyles: {
                0: { cellWidth: totalWidth * 0.2 },
                1: { cellWidth: totalWidth * 0.14 },
                2: { cellWidth: totalWidth * 0.2 },
                3: { cellWidth: totalWidth * 0.2 },
                4: { cellWidth: totalWidth * 0.26 },
            },
            didParseCell: function(data) {
                if (data.column.index === 4) {
                    data.cell.styles.fontSize = 9 // reduce size of scopes text
                }
            },
        })
        descriptionOptions.startY = pdf.autoTable.previous.finalY - 7
        // notes
        pdf.autoTable({
            head: [['Notes']],
            body: [[packingList.notes ? packingList.notes : '-'], []],
            ...descriptionOptions,
            columnStyles: {
                0: { cellWidth: totalWidth * 1 },
            },
        })

        descriptionOptions.startY = pdf.autoTable.previous.finalY - 5
        descriptionOptions.headStyles = {
            fillColor: [41, 128, 186],
            textColor: [256, 256, 256],
        }
        let index = 0
        let totalItems = 0
        let totalMass = 0
        let netMass = 0
        let totalSuggestedMass = 0
        let netSuggestedMass = 0
        let totalSuggestedItems = 0

        packingList.packages.forEach(pck => {
            index++

            // calculate package mass
            const packageMass = pck.items
                ? pck.items
                      .reduce(
                          (accumulator, item) =>
                              accumulator +
                              num(item.packingQty) * num(item.mass),
                          0
                      )
                      .toFixed(1)
                : 0
            totalMass += num(packageMass)
            netMass += num(packageMass)
            totalMass += num(pck.packageDimensions?.mass)
            //calculate total suggested mass
            const suggestedMass = pck.items
                ? pck.items
                      .reduce(
                          (accumulator, item) =>
                              accumulator +
                              (item.suggestedQty || 0) * item.mass,
                          0
                      )
                      .toFixed(1)
                : 0

            totalSuggestedMass += Number(suggestedMass)
            netSuggestedMass += Number(suggestedMass)
            totalSuggestedMass += Number(pck.packageDimensions.mass || 0)
            // calculate package qty
            const packageQty = pck.items
                ? pck.items
                      .reduce(
                          (accumulator, item) =>
                              accumulator + num(item.packingQty),
                          0
                      )
                      .toFixed(0)
                : 0

            const suggestedQty = pck.items
                ? pck.items
                      .reduce((acc, i) => acc + num(i.suggestedQty), 0)
                      .toFixed(0)
                : 0
            totalItems += num(packageQty)
            totalSuggestedItems += num(suggestedQty)
            // add table
            //suggested table
            if (useSuggested) {
                const packageTitle = `PACKAGE ${index} (W${
                    pck.packageDimensions.width
                } x H${pck.packageDimensions.height} x L${
                    pck.packageDimensions.depth
                } ${pck.packageDimensions.units} - Crate Mass: ${num(
                    pck.packageDimensions?.mass
                ).toFixed(1)} Kg - BOM: ${pck.packageBOM || ''})`

                // Margin top for title.
                descriptionOptions.startY += 6

                // Blue Background for title
                pdf.setFillColor(41, 128, 185) // same color of headers.
                pdf.rect(
                    10,
                    descriptionOptions.startY,
                    pdf.internal.pageSize.width - 20,
                    7,
                    'F'
                )

                // White text for title.
                pdf.setTextColor(255, 255, 255)
                pdf.setFontSize(9)
                pdf.setFont('helvetica', 'bold')
                pdf.text(packageTitle, 12, descriptionOptions.startY + 5)

                // Restore text color to black.
                pdf.setTextColor(0, 0, 0)

                // Adjust the space before the table.
                descriptionOptions.startY += 7

                pdf.autoTable({
                    startY: descriptionOptions.startY,
                    head: [
                        [
                            'Item',
                            'Work Order',
                            'Part Number',
                            'Description',
                            'Finish & UC Code',
                            'Suggested Qty',
                            'Confirmed Qty',
                            'Weight',
                            'Suggested Mass',
                            'Confirmed Mass',
                            'Notes',
                        ],
                    ],
                    body: [
                        ...pck.items.map((item, index) => [
                            index + 1,
                            item.bom
                                ? 'BOM ' + item.bom
                                : 'WO ' + item.workOrder,
                            item.bom ? item.code : item.partNumber,
                            item.description,
                            processFinish(item, settingFinish),
                            num(item.suggestedQty),
                            num(item.packingQty),
                            `${num(item.mass).toFixed(1)} Kg`,
                            `${formatNumber(
                                num(item.suggestedQty) * num(item.mass)
                            )} Kg`,
                            `${formatNumber(item.packingMass)} Kg`,
                            item.notes,
                        ]),
                        [
                            '',
                            'Total',
                            '',
                            '',
                            '',
                            `${num(suggestedQty).toFixed(0)}`,
                            `${num(packageQty).toFixed(0)}`,
                            '',
                            `${formatNumber(num(suggestedMass))} kg`,
                            `${formatNumber(num(packageMass))} kg`,
                            '',
                        ],
                    ],
                    ...descriptionOptions,
                    styles: { fontSize: 8 },
                    headStyles: {
                        fontSize: 9,
                    },
                    columnStyles: {
                        0: { cellWidth: totalWidth * 0.06 },
                        1: { cellWidth: totalWidth * 0.12 },
                        2: { cellWidth: totalWidth * 0.12 },
                        3: { cellWidth: totalWidth * 0.1 },
                        4: { cellWidth: totalWidth * 0.1 },
                        5: { cellWidth: totalWidth * 0.08 },
                        6: { cellWidth: totalWidth * 0.07 },
                        7: { cellWidth: totalWidth * 0.07 },
                        8: { cellWidth: totalWidth * 0.07 },
                        9: { cellWidth: totalWidth * 0.12 },
                        10: { cellWidth: totalWidth * 0.09 },
                    },
                })
            } else {
                if (packageQty > 0) {
                    const packageTitle = `PACKAGE ${index} (W${
                        pck.packageDimensions.width
                    } x H${pck.packageDimensions.height} x L${
                        pck.packageDimensions.depth
                    } ${pck.packageDimensions.units} - Crate Mass: ${num(
                        pck.packageDimensions?.mass
                    ).toFixed(1)} Kg - BOM: ${pck.packageBOM || ''})`

                    // Margin top for title.
                    descriptionOptions.startY += 6

                    // Blue Background for title
                    pdf.setFillColor(41, 128, 185) // same color of headers.
                    pdf.rect(
                        10,
                        descriptionOptions.startY,
                        pdf.internal.pageSize.width - 20,
                        7,
                        'F'
                    )

                    // White text for title.
                    pdf.setTextColor(255, 255, 255)
                    pdf.setFontSize(9)
                    pdf.setFont('helvetica', 'bold')
                    pdf.text(packageTitle, 12, descriptionOptions.startY + 5)

                    // Restore text color to black.
                    pdf.setTextColor(0, 0, 0)

                    // Adjust the space before the table.
                    descriptionOptions.startY += 6

                    pdf.autoTable({
                        startY: descriptionOptions.startY,
                        head: [
                            [
                                'Item',
                                'Work Order',
                                'Part Number',
                                'Description',
                                'Finish & UC Code',
                                'Qty',
                                'Weight',
                                'Total',
                                'Notes',
                                'OC',
                                'Position',
                            ],
                        ],
                        body: [
                            ...pck.items
                                .filter(item => num(item.packingQty) > 0)
                                .map((item, index) => [
                                    index + 1,
                                    item.bom
                                        ? 'BOM ' + item.bom
                                        : 'WO ' + item.workOrder,
                                    item.bom ? item.code : item.partNumber,
                                    item.description,
                                    processFinish(item, settingFinish),
                                    num(item.packingQty),
                                    `${num(item.mass).toFixed(1)} Kg`,
                                    `${formatNumber(item.packingMass)} Kg`,
                                    item.notes,
                                    item.oc ?? '',
                                    item.costPosition ?? '',
                                ]),
                            [
                                '',
                                'Total',
                                '',
                                '',
                                '',
                                `${num(packageQty).toFixed(0)}`,
                                '',
                                `${formatNumber(num(packageMass))} kg`,
                                '',
                                '',
                                '',
                            ],
                        ],
                        ...descriptionOptions,
                        styles: { fontSize: 8 },
                        headStyles: { fontSize: 9 },
                        columnStyles: {
                            0: { cellWidth: totalWidth * 0.06 },
                            1: { cellWidth: totalWidth * 0.12 },
                            2: { cellWidth: totalWidth * 0.12 },
                            3: { cellWidth: totalWidth * 0.1 },
                            4: { cellWidth: totalWidth * 0.1 },
                            5: { cellWidth: totalWidth * 0.08 },
                            6: { cellWidth: totalWidth * 0.07 },
                            7: { cellWidth: totalWidth * 0.07 },
                            8: { cellWidth: totalWidth * 0.07 },
                            9: { cellWidth: totalWidth * 0.12 },
                            10: { cellWidth: totalWidth * 0.09 },
                        },
                    })
                    // Update Y position
                    descriptionOptions.startY =
                        pdf.autoTable.previous.finalY + 5
                }
            }
            descriptionOptions.startY = pdf.autoTable.previous.finalY + 5
        })

        // Add totals header
        pdf.setFont('helvetica', 'bold')
        pdf.setFillColor(230, 230, 230)
        pdf.rect(
            10,
            descriptionOptions.startY,
            pdf.internal.pageSize.width - 20,
            10,
            'F'
        )

        const headers = [
            'TOTAL',
            `PACKAGES: ${index}`,
            `ITEMS: ${Number(
                useSuggested ? totalSuggestedItems : totalItems
            ).toFixed(0)}`,
            `NET MASS: ${formatNumber(
                Number(useSuggested ? netSuggestedMass : netMass)
            )} Kg`,
            `GROSS MASS: ${formatNumber(
                Number(useSuggested ? totalSuggestedMass : totalMass)
            )} Kg`,
        ]
        const cellWidths = [
            totalWidth * 0.12,
            totalWidth * 0.18,
            totalWidth * 0.16,
            totalWidth * 0.26,
            totalWidth * 0.28,
        ]

        let currentX = 0
        headers.forEach((header, index) => {
            pdf.text(header, currentX + 15, descriptionOptions.startY + 6)
            currentX += cellWidths[index]
        })

        const marginLeft = 20
        const marginRight = pdf.internal.pageSize.width - 20
        const signatureLineY = descriptionOptions.startY + 30
        const labelY = signatureLineY + 5

        pdf.line(marginLeft, signatureLineY, marginLeft + 80, signatureLineY)
        pdf.line(marginRight - 80, signatureLineY, marginRight, signatureLineY)

        pdf.text('Delivers', marginLeft, labelY)
        pdf.text('Receives', marginRight - 80, labelY)

        const pdfDataUri = pdf.output('datauristring')
        const blob = dataURItoBlob(pdfDataUri)
        if (returnBlob) {
            return blob
        }
        const blobURL = URL.createObjectURL(blob)
        const printWindow = window.open(blobURL)
        if (printWindow) {
            printWindow.onload = function() {
                printWindow.print()
                URL.revokeObjectURL(blobURL)
            }
        }
    } catch (error) {
        console.log(error)
        if (returnBlob) {
            throw error
        }
    }
}

const getAspectRatio = async file => {
    return new Promise(function(resolved) {
        var i = new Image()
        i.onload = function() {
            resolved(i.width / i.height)
        }
        i.src = file
    })
}

const dataURItoBlob = dataURI => {
    const byteString = Uint8Array.from(atob(dataURI.split(',')[1]), c =>
        c.charCodeAt(0)
    )
    const blobType = dataURI
        .split(',')[0]
        .split(':')[1]
        .split(';')[0]
    return new Blob([byteString], { type: blobType })
}

const findUserInfo = (users, id) => {
    let user = { name: '', phone: '' }
    const userFound = users.find(u => u.id == id)
    if (userFound) {
        user = userFound
    }
    return user
}

const processFinish = (item, settingFinish) => {
    if (item.finishAndUCCode && settingFinish) {
        const finish = settingFinish.finishes.find(
            e => e.id === item.finishAndUCCode
        )
        if (finish && finish.description) {
            return `${finish.description}`
        } else {
            return '-'
        }
    } else {
        return '-'
    }
}
const formatNumber = value => (+value || 0).toFixed(1)
